import { render, staticRenderFns } from "./ModalEditExtendPhaseTermAcademic.vue?vue&type=template&id=02b6b822"
import script from "./ModalEditExtendPhaseTermAcademic.vue?vue&type=script&lang=js"
export * from "./ModalEditExtendPhaseTermAcademic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports